import Field from 'field/Field';
import Component from 'navigation/component/Component';
class PasswordField extends Component {
    button;
    placeholder;
    bindModules() {
        return {
            field: ['.field', Field]
        };
    }
    constructor(el, { parent }) {
        super(el);
        this.button = this.el.parentNode.querySelector('.field__show');
        this.placeholder = this.el.placeholder;
    }
    bindEvents(add = true) {
        const method = add ? 'addEventListener' : 'removeEventListener';
        this.button[method]('click', this.onClick);
    }
    onClick = (e) => {
        e.preventDefault();
        const show = this.el.type === 'password';
        this.el.type = show ? 'text' : 'password';
        this.el.style.textTransform = show ? 'none' : 'uppercase';
        this.el.placeholder = show ? '' : this.placeholder;
        this.button.innerText = this.button.getAttribute('data-label').split('|')[show ? 1 : 0];
    };
}
export default PasswordField;
